// extracted by mini-css-extract-plugin
export default {"DialogExplorer":"DialogExplorer_DialogExplorer__himOA","MyDialog":"DialogExplorer_MyDialog__aldic","TheirDialog":"DialogExplorer_TheirDialog__ReVqj"};